<template>
    <svg class="svg-container">
        <path v-for="path in connectors()" :d="path.path" :key="path.id" />
        <path
            v-for="path in connectors().filter((x) => isSelected(x.id))"
            :d="path.path"
            :key="path.id + '-selected'"
            class="selected"
        />
    </svg>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../utils/log2";
import { mapState } from "vuex";

const log = log2("BlockConnectors");
export default {
    name: "BlockConnectors",
    props: ["blocks", "metas"],
    computed: {
        ...mapState({
            testState: (state) => state.automation.testState,
        }),
    },
    methods: {
        calculateConnector(parent, i) {
            const isLast = i === this.blocks.length - 1;
            if (isLast && parent.type === "FLOW") return [];
            const sourceMeta = this.metas[parent.id];
            // log("sourceMeta", sourceMeta);
            const sourceX = sourceMeta.x;
            const sourceY = sourceMeta.y;
            const sourceWidth = sourceMeta.width;
            const sourceHeight = sourceMeta.height;
            const childCount = parent.children.length;
            const isOddBlockLength = childCount % 2 === 1;
            const middleIndex = (childCount - 1) / 2.0;
            return parent.children
                .map((child, i) => {
                    const targetMeta = this.metas[child.id];
                    if (!targetMeta) return null;
                    const targetX = targetMeta.x;
                    const targetY = targetMeta.y;
                    const targetWidth = targetMeta.width;
                    const targetHeight = targetMeta.height;
                    const isMiddleBlock = childCount === 1 || (isOddBlockLength && i === middleIndex);
                    const isCurved = isMiddleBlock ? false : childCount > 1;

                    let path = "";
                    if (isCurved) {
                        const moveX = sourceX + sourceWidth + 5;
                        const moveY = sourceY + sourceHeight / 2;
                        const cX1 = sourceX + sourceWidth + 50;
                        const cY1 = sourceY + sourceHeight / 2;
                        const cX2 = targetX - 60;
                        const cY2 = targetY + targetHeight / 2;
                        const endX = targetX - (targetMeta.isSquare ? 15 : 0);
                        const endY = targetY + targetHeight / 2;
                        path = `M${moveX} ${moveY} C ${cX1} ${cY1} ${cX2} ${cY2} ${endX} ${endY}`;
                    } else {
                        path = `M${sourceX + sourceWidth + (sourceMeta.isSquare ? 15 : 10)} ${
                            sourceY + sourceHeight / 2
                        } L ${targetX - (targetMeta.isSquare ? 15 : 10)} ${targetY + targetHeight / 2}`;
                    }
                    return {
                        path,
                        id: child.id,
                    };
                })
                .filter(Boolean);
        },
        connectors() {
            const connectors = _.flatten(this.blocks.map((block, i) => this.calculateConnector(block, i)));
            // log("connectors", connectors);
            return connectors;
        },
        isSelected(blockId) {
            if (this.testState.startBlockId === blockId) return false;
            const isClosed = _.get(this.testState, "active", false) === false;
            const selectedPaths = isClosed ? [] : _.get(this.testState, "history", []);
            // log("isSelected", { selectedPaths, blockId, result: selectedPaths.includes(blockId) });
            return selectedPaths.includes(blockId);
        },
    },

    mounted() {
        log("mounted", {
            blocks: this.blocks,
            metas: this.metas,
        });
    },
    watch: {
        blocks: function () {
            // log("blocks", {
            //     blocks: this.blocks,
            //     metas: this.metas,
            // });
        },
        metas: function () {
            // log("metas", {
            //     blocks: this.blocks,
            //     metas: this.metas,
            // });
        },
    },
};
</script>

<style lang="scss">
.svg-container {
    overflow: visible !important;
    pointer-events: none;
    position: absolute;

    path {
        fill: none;
        stroke-width: 2.5px;
        stroke: #c9d3de;
        transition: all 0.7s;
        animation-duration: 3s;
    }

    path.selected {
        stroke: #006cff;
        animation-name: lineanim;
        animation-timing-function: ease-in;
    }

    @keyframes lineanim {
        0% {
            stroke-dashoffset: 1000;
            stroke-dasharray: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
}
</style>
